import React from 'react'
import { apiFetch } from '../fetchApi';

export const deleteLanguage = ({ BeURL, showAlert, setLanguage, id, candidateId }) => {
    apiFetch(`${BeURL}/language-delete/${id}/${candidateId}`, {
        method: "DELETE",
      
    })
        .then((res) => res.json())
        .then((data) => {
            if (data.success) {
                showAlert(data.message);
                setLanguage(data.languages)
            } else {
                showAlert(data.message);
            }
        })
        .catch((err) => {
            console.log("Error in delete language", err);
        });
}
